import * as React from "react";
const PrintDarkIcon = (props) => (
	<svg
		width={26}
		height={26}
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M21 19.667c1.242 0 1.864 0 2.354-.204a2.67 2.67 0 0 0 1.443-1.443c.203-.49.203-1.11.203-2.353v-5.071c0-1.49 0-2.237-.29-2.807a2.67 2.67 0 0 0-1.167-1.165c-.535-.273-1.225-.29-2.543-.29m0 0H5m16 0H5m16 0V5.262c0-1.491 0-2.237-.29-2.807a2.67 2.67 0 0 0-1.167-1.165C18.973 1 18.227 1 16.733 1H9.268c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C5 3.026 5 3.773 5 5.266v1.067m0 0c-1.318.001-2.009.018-2.544.291a2.66 2.66 0 0 0-1.165 1.165C1 8.36 1 9.107 1 10.6v5.067c0 1.242 0 1.863.203 2.353.27.654.79 1.173 1.443 1.444.49.203 1.111.203 2.354.203m5.333-8h5.334M9 17h8c1.242 0 1.864 0 2.354.203.653.27 1.172.79 1.443 1.443C21 19.136 21 19.757 21 21c0 1.242 0 1.864-.203 2.354a2.67 2.67 0 0 1-1.443 1.443C18.864 25 18.243 25 17 25H9c-1.243 0-1.864 0-2.354-.203a2.67 2.67 0 0 1-1.443-1.443C5 22.864 5 22.242 5 21c0-1.243 0-1.864.203-2.354.27-.654.79-1.172 1.443-1.443C7.136 17 7.757 17 9 17"
			stroke="#5E666B"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default PrintDarkIcon;
